import { Navigate, Outlet } from "react-router-dom";
import { useMe } from "../../hooks/useMe";

/**
 * Route guard that redirects banned/suspended users to their profile page.
 * Wrap routes that banned users should not access.
 */
export const RequireActive = () => {
  const { user } = useMe();

  if (user?.isBanned) {
    return <Navigate to="/profile" replace />;
  }

  return <Outlet />;
};
